import { z } from 'zod'

export const schema = z.object({
    razaoSocial: z.string().nonempty('Campo obrigatório'),
    cpfCnpj: z.string().nonempty('Campo obrigatório'),
    codParc: z.string().nonempty('Campo obrigatório'),
    endereco: z.string().nonempty('Campo obrigatório'),
    numero: z.string().nonempty('Campo obrigatório'),
    complemento: z.string().optional(),
    bairro: z.string().nonempty('Campo obrigatório'),
    cidade: z.string().nonempty('Campo obrigatório'),
    uf: z.string().nonempty('Campo obrigatório'),
    cep: z
        .string()
        .nonempty('Campo obrigatório')
        .refine((cep) => cep.replace(/[^0-9]/g, '').length === 8, {
            message: 'CEP inválido',
        }),
    telefone: z.string().nonempty('Campo obrigatório'),
    ramal: z.string().optional(),
})
